// Single source of the quote aggregate PATCH payload. QuotePlugin's draft-time
// sync and the activation PATCH must write identical fields from identical
// summary inputs, or activation can persist aggregates the plugin would
// immediately rewrite.
type SummaryAggregates = {
  totalCost: number
  subtotalWithSuppliesAndDiscounts: number
  discounts: { total: number }
  tax: { price: number }
  total: number
  labor: { hours: number }
}

export function quoteAggregatePayload(summary: SummaryAggregates) {
  return {
    msdyn_estimatedcost: summary.totalCost,
    totallineitemamount: summary.subtotalWithSuppliesAndDiscounts,
    totaldiscountamount: Math.abs(summary.discounts.total),
    totaltax: summary.tax.price,
    totalamount: summary.total,
    dsy_totalhours: summary.labor.hours,
  }
}

export type QuoteAggregatePayload = ReturnType<typeof quoteAggregatePayload>
